import { useState } from 'react';
import type { AlertColor } from '@mui/material';  // Import AlertColor type

const useSnackbar = () => {
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState<AlertColor>('success');  // Use AlertColor

    const showSnackbar = (message: string, severity: AlertColor = 'success') => {  // Use AlertColor
        setSnackbarMessage(message);
        setSnackbarSeverity(severity);
        setSnackbarOpen(true);
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    return { snackbarOpen, snackbarMessage, snackbarSeverity, showSnackbar, handleSnackbarClose };
};

export default useSnackbar;